<template>
  <Layout>
    <template #default>
      <div class="container-fluid p-0 m-0 background1">
        <div class="row bg-Hellgrau pt-3 pb-3 justifyCenter" id="t0">
          <div class="col-md-4 t-center spacebetween">
            <div class="div borderRund rundKopf">
              <a href="#t0">
                <h5 v-if="sprachID === 0">Jahreshauptversammlung</h5>
                <h5 v-if="sprachID === 1">annual general meeting</h5>
              </a>
            </div>
            <div class="div borderRund rundKopf">
              <a href="#t1">
                <h5 v-if="sprachID === 0">Herbsttagung</h5>
                <h5 v-if="sprachID === 1">autumn conference</h5>
              </a>
            </div>
          </div>
        </div>
        <div class="row bg-Hellgrau pt-3 pb-3 justifyCenter">
          <div class="col-md-8 t-center text-Weiss" v-if="sprachID === 0">
            Jährlich finden zwei Tagungen statt, im Frühjahr und im Herbst.
            <br />
            Die Frühjahrstagung ist gleichzeitig auch Jahreshauptversammlung der
            Mitglieder des AfM.
          </div>
          <div class="col-md-8 t-center text-Weiss" v-if="sprachID === 1">
            Two conferences are held each year, in spring and autumn. <br />
            The spring conference is also the annual general meeting of the
            Members of the AfM.
          </div>
        </div>

        <div class="row justifyCenter bg-WeissTransparent" id="t0">
          <div class="col-md-10 t-center aussendiv text-Rot-Schatten">
            <div class="pt-5 pb-5">
              <h1 v-if="sprachID === 0">Jahreshauptversammlung</h1>
              <h1 v-if="sprachID === 1">annual general meeting</h1>
            </div>
          </div>
        </div>
        <div class="row justifyCenter pb-5 bg-WeissTransparent">
          <div class="col-md-8 t-center aussendiv">
            <p v-if="sprachID === 0">
              <b> Die JHV 2023 findet vom 21. – 23. 04. 2023 statt.</b>
            </p>
            <p v-if="sprachID === 1">
              <b> The AGM 2023 will take place from April 21 - 23, 2023 </b>
            </p>
            <article class="p-2">
              Besucher der Tagung (JHV)j setzen sich bitte direkt mit Herrn Uwe Lehmann 0162 4248389 
              oder Mail an lehmann-radeburg@web.de in Verbindung
            </article>
           
            
          </div>
        </div>
       

        


        <div class="row justifyCenter bg-WeissTransparent pt-5" id="t1">
          <div class="col-md-10 t-center aussendiv text-Rot-Schatten pb-5">
            <h1 v-if="sprachID === 0">Herbsttagung</h1>
            <h1 v-if="sprachID === 1">autumn conference</h1>
          </div>
        </div>
        <div class="row justifyCenter bg-WeissTransparent pb-5">
          <div class="col-md-10 t-center aussendiv">
            <h4 v-if="sprachID === 0">
              Die nächste Herbsttagung findet voraussichtlich im Oktober 2023 im
              Raum Osnabrück statt.
            </h4>
            <h4 v-if="sprachID === 1">
              <b>
                The next autumn conference is expected to take place in October
                2023 in the Osnabrück area.
              </b>
            </h4>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from "@/layouts/Layout";
import { openModal } from "jenesius-vue-modal";
import modalPDF from "../components/ModalPDF.vue";

export default {
  name: "Praxis",

  data() {
    return {
      newSite: null,
    };
  },
  components: {
    Layout,
  },
  methods: {openPDF(pdf) {
      const props = { pdf: pdf };
      openModal(modalPDF, props);
    },   },
  computed: {
    sprachID() {
      let sprachID = this.$store.getters.getSprachID;
      return sprachID;
    },
  },
};
</script>

<style scoped></style>
